module.exports = __webpack_public_path__ + "img/Car.svg.63d53fa7.png";